import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledMultiSelectWrapper = styled.div`
  width: max-content;
  max-width: 100%;
  position: relative;
`;

export const StyledMultiSelectButton = styled.button`
  width: 100%;
  background-color: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4375rem 0.875rem;
  height: 38px;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: -0.005em;
  color: var(--ink);
  transition: border-color 160ms ease, box-shadow 160ms ease;
  &:hover {
    border-color: var(--brand-green);
  }
  &:focus-visible,
  &.is-open {
    border-color: var(--brand-green);
    box-shadow: 0 0 0 3px rgba(118, 177, 89, 0.15);
  }
  &[disabled],
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const StyledMultiSelectButtonText = styled.span`
  display: inline-block;
  width: calc(100% - 1.75rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledMultiSelectEntityBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: 0.375rem;
  padding: 1px 6px;
  border-radius: var(--r-full);
  background-color: var(--paper-2);
  color: var(--muted);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  flex-shrink: 0;
`;

export const StyledMultiSelectButtonIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--ink-2);
  margin-right: 4px;
  svg {
    width: 14px;
    height: 14px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const StyledMultiSelectButtonDecor = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-left: 0.5rem;
  color: var(--muted-2);
  transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1);
  svg {
    height: 14px;
    width: 14px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const StyledMultiSelectContent = styled(motion.div).attrs({
  key: 'multiselect-dropdown',
  initial: { opacity: 0, y: '-6px', scale: 0.98 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: '-6px', scale: 0.98 },
  transition: { duration: 0.15, type: 'tween' },
})`
  width: calc(100% + 6rem);
  position: absolute;
  top: calc(100% + 0.375rem);
  background-color: var(--surface);
  border: 1px solid var(--line);
  box-shadow: 0 4px 6px -2px rgba(9, 15, 56, 0.04),
    0 12px 32px -8px rgba(9, 15, 56, 0.12);
  border-radius: var(--r-lg);
  padding: 0.625rem;
  max-height: 24rem;
  overflow: auto;
  z-index: ${({ theme }) => theme.zindexes.autocomplete};

  & > div:first-child {
    border-bottom: 1px solid var(--line);
    margin-bottom: 0.375rem;
    padding-bottom: 0.25rem;
  }
`;
